import React, { FC, memo, useEffect } from "react";
import { createUseStyles, Styles } from "react-jss";

import Point from "Assets/images/point.svg";
import LocationBlue from "Assets/images/location_blue.svg";
import SwitchStartDestination from "Assets/images/switch_start_destination.svg";
import WayPoints from "Components/Waypoints";
import Autocomplete from "Containers/AutoComplete";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  showDirections;
  suggestions: any[];
  startingPoint: any;
  destination: any;
  setStartingPoint: (val: any) => void;
  setDestination: (val: any) => void;
  swap: () => void;
  setShowDirections: (setShowDirections: boolean) => void;
  instructions: string[];
  directionsRef: any;
}
type StyleProps = { theme?: unknown } & Partial<Props>;

const StartDestination: FC<Props> = memo((props: Props) => {
  const useStyles = createUseStyles<string, StyleProps>(
    styles as Styles<string, StyleProps>
  );
  const classes = useStyles(props as StyleProps);
  const {
    showDirections,
    suggestions,
    startingPoint,
    destination,
    setStartingPoint,
    setDestination,
    setShowDirections,
    swap,
    instructions,
    directionsRef,
  } = props;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const closeButton = document.getElementById("close-button");
      if (
        event.key === "Tab" &&
        document.activeElement.id === "switch-button" &&
        closeButton &&
        instructions.length === 0
      ) {
        event.preventDefault();
        closeButton.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line
  }, [suggestions]);

  return (
    <div
      id="startDestination"
      className={`${classes.mainContainer} ${
        showDirections ? "" : classes.startLeft
      }`}
    >
      <div style={{ marginRight: "20px" }} className={classes.iconsContainer}>
        <Point />
        <div className={classes.stop} />
        <div className={classes.stop} />
        <div className={classes.stop} />
        <LocationBlue />
      </div>
      <div className={classes.inputContainer}>
        <Autocomplete
          isStartingPoint
          setShowDirections={setShowDirections}
          placeholder="Choose starting point"
          selectedInputValue={startingPoint.title || ""}
          setUserSelection={setStartingPoint}
          suggestions={suggestions}
          directionsRef={directionsRef}
        />
        <Autocomplete
          isStartingPoint={false}
          setShowDirections={setShowDirections}
          placeholder="Choose destination"
          selectedInputValue={destination.title || ""}
          setUserSelection={setDestination}
          suggestions={suggestions}
          directionsRef={null}
        />
      </div>
      <button
        id="switch-button"
        aria-label="Switch start and destination"
        className={showDirections ? classes.switchButton : classes.switchDest}
        onClick={swap}
      >
        <SwitchStartDestination className={classes.switch} />
      </button>
      {instructions?.length > 0 && (
        <WayPoints steps={instructions} showTitle={false} />
      )}
    </div>
  );
}, areEqualShallow);

export default StartDestination;
